import { render, staticRenderFns } from "./SEOContentBlock.vue?vue&type=template&id=30ef0199&lang=pug&"
import script from "./SEOContentBlock.vue?vue&type=script&lang=js&"
export * from "./SEOContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./SEOContentBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ef0199')) {
      api.createRecord('30ef0199', component.options)
    } else {
      api.reload('30ef0199', component.options)
    }
    module.hot.accept("./SEOContentBlock.vue?vue&type=template&id=30ef0199&lang=pug&", function () {
      api.rerender('30ef0199', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/SEOContentBlock.vue"
export default component.exports